class ReactQueryHook<T> {
    constructor(public isLoading: boolean, public error: unknown, public data: T) {}
}

export default ReactQueryHook;
